// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hPHp","delete":"styles_delete__MEBq_","update":"styles_update__1MScK","add":"styles_add__3WwOw"};